import { render, staticRenderFns } from "./JobPreviewCommentThread.vue?vue&type=template&id=4977280d"
import script from "./JobPreviewCommentThread.vue?vue&type=script&lang=js"
export * from "./JobPreviewCommentThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports